import api from './api';

export const remittancesService = {
  getAll: async (params = {}) => {
    const response = await api.get('/remittances', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/remittances/${id}`);
    return response.data;
  },

  // Images are behind auth (not public /uploads), so fetch as a blob with the
  // normal Authorization header rather than using a plain <img src="..."> URL.
  getImageBlobUrl: async (id, index) => {
    const response = await api.get(`/remittances/${id}/image/${index}`, { responseType: 'blob' });
    return URL.createObjectURL(response.data);
  },

  update: async (id, data) => {
    const response = await api.patch(`/remittances/${id}`, data);
    return response.data;
  },

  updateLineItem: async (id, lineItemId, data) => {
    const response = await api.patch(`/remittances/${id}/line-items/${lineItemId}`, data);
    return response.data;
  },

  markReviewed: async (id) => {
    const response = await api.patch(`/remittances/${id}`, { status: 'reviewed' });
    return response.data;
  },

  remove: async (id) => {
    const response = await api.delete(`/remittances/${id}`);
    return response.data;
  }
};

export default remittancesService;
